export const UNSUBMITTED = 'UNSUBMITTED'
export const NONSUBMIT = 'NONSUBMIT'
export const PENDING = 'PENDING'
export const APPROVED = 'APPROVED'
export const REJECTED = 'REJECTED'
export const POSTPONE = 'POSTPONE'
export const HOLIDAY = 'HOLIDAY'
export const COMPENSATE = 'COMPENSATE'
export const LEAVE = 'LEAVE'
export const WEEKEND = 'WEEKEND'
export const FULLDAY = 'FULLDAY'

export const FIXFEE = 'FIXFEE'
export const TIME_MATERIAL = 'TIME_MATERIAL'
export const SUPPORT = 'SUPPORT'
export const COMMON = 'COMMON'
export const SPECIFIC = 'SPECIFIC'

export const leave_history_table_header = [
  { label: 'Status', value: 0 },
  { label: 'Request Type', value: 1 },
  { label: 'Duration', value: 2 },
  { label: 'Total Leave Day', value: 3 },
  { label: 'Approver', value: 4 },
  { label: 'Submit Date', value: 5 },
]



// WEBPACK FOOTER //
// ./src/components/my-leave/constants.js